import { Component } from '@angular/core';
import {AlertasService} from "../../../services/alertas.service";

@Component({
  selector: 'app-alerta-msg',
  templateUrl: './alerta-msg.component.html',
  styleUrls: ['./alerta-msg.component.scss']
})
export class AlertaMsgComponent {
  constructor(
    public alertaService: AlertasService
  ) {

  }
}
